<template>
  <div>
    <!--  协议  -->
    <div class="agreement-btn">
      <div v-if="canAgreeSwitch" class="select-wrap">
        <img
          v-if="isClicked"
          class="selected"
          :style="`background-color:${userAgreement.select_color || ''}`"
          src="./assets/right.svg"
          @click="handleAgree(false)"
        />
        <div v-else class="unselect-wrap" @click="handleAgree(true)">
          <div class="unselect" />
        </div>
      </div>
      <span
        class="option-text"
        :style="`color:${userAgreement.txt_color || ''}`"
      >
        {{ userAgreement.agreement_prefix || '' }}
      </span>
      <span
        v-for="(item, index) in userAgreement.agreeList"
        :key="index"
        class="option-agreement"
        :style="`color:${userAgreement.color || ''}`"
        @click="showPolicy(index)"
        >{{ item.name }}</span
      >
      <!-- <span class="option-agreement" :style="`color:${userAgreement.color || ''}`" @click="showPolicy(0)">{{ userAgreement.agreement_name || '' }}</span>
      <span class="option-agreement" :style="`color:${userAgreement.color || ''}`" @click="showPolicy(1)">《隐私政策》</span>-->
    </div>

    <!--  协议弹窗  -->
    <Agreement
      v-if="isShowAgreeModal"
      :res="agreeModalData"
      @closeHandle="toggeleAgreetModal(false)"
    ></Agreement>
  </div>
</template>

<script lang='ts'>
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { IAgree, IAgreeModal } from './type';
import Agreement from '@component/enrolment-comp/agreement.vue';

@Component({
  components: { Agreement },
})
export default class ContentAgreement extends Vue {
  @Prop({ default: true }) canAgreeSwitch!: boolean; // 是否有协议前√按钮
  @Prop({ default: true }) showDefaultModal!: boolean; // 弹窗样式是否使用默认
  @Prop({}) userAgreement!: IAgree;
  @Prop({ default: true }) defaultAgreeStatus!: boolean;

  isClicked = true;
  isShowAgreeModal = false;
  agreeModalData: IAgreeModal = {} as any;

  mounted() {
    this.isClicked = this.defaultAgreeStatus;
  }

  @Watch('isClicked')
  initAgreeStatus(newVal: boolean, oldVal: boolean) {
    if (newVal !== oldVal) {
      this.$emit('toggleAgree', this.isClicked);
    }
  }

  handleAgree(isClicked: boolean) {
    this.isClicked = isClicked;
  }

  toggeleAgreetModal(isShowAgreeModal: boolean) {
    this.isShowAgreeModal = isShowAgreeModal;
  }
  showPolicy(index: number) {
    if (!this.showDefaultModal) {
      this.$emit('showPolicy', true, index);
    } else {
      this.agreeModalData = this.userAgreement.agreeList[index].modal;
      this.toggeleAgreetModal(true);
    }
  }
}
</script>

<style lang='scss' scoped>
.agreement-btn {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  .select-wrap {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    width: 48px;
    height: 48px;

    .selected {
      width: 24px;
      height: 24px;
      border-radius: 4px;
    }

    .unselect-wrap {
      position: relative;
      width: 100%;
      height: 100%;
      // z-index: 0;
      padding: 12px;

      .unselect {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 24px;
        height: 24px;
        border: solid 2px #979797;
        border-radius: 4px;
        transform: translate(-50%, -50%);
        // z-index: 0;
      }
    }
  }
  .option-text {
    display: block;
    font-size: 20px;
    white-space: nowrap;
    opacity: 0.6;
  }
  .option-agreement {
    display: block;
    font-size: 20px;
    white-space: nowrap;
  }
}
</style>